module.exports = __webpack_public_path__ + "static/media/overpass-light-italic.14564a08.eot";